import type {
  AlertProps as MuiAlertProps,
  AlertTitleProps,
} from '@mui/material'
import { Alert as MuiAlert, AlertTitle } from '@mui/material'
import type { ReactNode } from 'react'

export interface AlertProps extends Omit<MuiAlertProps, 'title'> {
  title?: ReactNode | string
  description?: ReactNode | string
  titleProps?: AlertTitleProps
}

export function ToastAlert(props: AlertProps) {
  const { title, description, titleProps, icon, ...alertProps } = props
  return (
    <MuiAlert
      icon={icon}
      {...alertProps}
      sx={{
        alignItems: 'center',
        gap: '12px',
        '& .MuiAlert-icon': {
          marginRight: 0,
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 0,
        },
        '& .MuiAlert-action': {
          padding: 0,
          marginRight:0
        },
        ...alertProps.sx,
      }}
    >
      {!!title && (
        <AlertTitle
          sx={{
            fontSize: '16px',
            fontWeight: '700',
            color: 'text1',
          }}
          {...titleProps}
        >
          {title}
        </AlertTitle>
      )}
      <span>{description}</span>
    </MuiAlert>
  )
}
